import { DevicePool, DevicePoolIdentifier, Pagination } from '@ekkogmbh/apisdk';
import { SelectProps } from '@mui/material';
import React from 'react';
import CoordinateListItem from 'src/Common/Components/CoordinateListItem';
import PaginatedSelect from 'src/Common/Components/Forms/PaginatedSelect';
import useEkko from 'src/Common/Providers/EkkoProvider';

interface Props {
  coordinate: string;
  selected?: DevicePoolIdentifier;
  optional?: boolean;
  onChange: (devicePool: DevicePoolIdentifier | undefined) => void;
  onError?: () => void;
  disabled?: boolean;
  renderValue?: SelectProps['renderValue'];
  label?: string;
}

export const DevicePoolPicker = ({ label, selected, optional, disabled, onChange }: Props): React.JSX.Element => {
  const { api } = useEkko();

  return (
    <PaginatedSelect
      optional={optional}
      label={label ?? 'Device Pool'}
      disabled={disabled}
      value={selected}
      onChange={(item) => onChange(item as DevicePoolIdentifier | undefined)}
      fetchPaginatedItems={(pagination: Pagination) => api.getDevicePools(pagination)}
      itemId={(item: DevicePoolIdentifier | DevicePool) => item.name + '::' + item.coordinate}
      itemRender={(item: DevicePoolIdentifier | DevicePool) => (
        <CoordinateListItem label={item.name} coordinate={item.coordinate} />
      )}
    />
  );
};
